<template>
  <div class="home">
    <HelloWorld msg="Welcome to Your Vue.js App" />
    <HelloWorld2 />
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  components: {}
};
</script>
